import { Tenant, TenantMemberAccess } from './tenant'

export enum UserRole {
  VIEWER = 'VIEWER',
  CONTRIBUTOR = 'CONTRIBUTOR',
  ADMIN = 'ADMIN',
}

export enum ONBOARDING_STEP {
  ONBOARDING_WELCOME = 'OnboardingWelcome',
  ONBOARDING_PERSONALIZE = 'OnboardingPersonalInfo',
  ONBOARDING_INTERESTS = 'OnboardingInterests',
  ONBOARDING_COPA = 'OnboardingCopa',
  ONBOARDING_DONE = 'OnboardingDone',
}

export interface IUser {
  role: UserRole
  id: string
  email: string
  firstName: string
  lastName: string
  company: string
  companyWebsite: string
  isSuperadmin: boolean
  companyRole: string
  interests: string[]
  isLetIn: boolean
  description: string
  purpose: string
  createdAt: string
  tenants: Tenant[]
  step: ONBOARDING_STEP
  updatedAt: string
  lastLoginAt: string
  avatarUrl: string | null
}

export interface IMember {
  id: string
  email: string
  firstName: string
  lastName: string
  company: string
  description: string
  purpose: string
  isLetIn: boolean
  marketingMailing: boolean
  lastLoginAt: string
  createdAt: string
  updatedAt: string
  tenantMemberAccess: TenantMemberAccess
}

export type UserPurpose = 'DevelopProject'

export interface CurrentUser {
  interests: string[]
  description: string
  purpose: string
  id: string
  email: string
  firstName: string
  lastName: string
  company: string
  companyWebsite: string
  companyRole: string
  role: UserRole
  step: ONBOARDING_STEP
  marketingMailing: boolean
  isOnboardingFinished: boolean
  isSuperadmin: boolean
  isLetIn: boolean
  createdAt: string
  updatedAt: string
  lastLoginAt: string
  avatarUrl: string | null
  tenants: Tenant[]
}

export interface UpdateCurrentUserBody {
  interests?: string[]
  description?: string[]
  firstName?: string
  lastName?: string
  company?: string
  role?: string
  step?: string
}

export interface UpdateCurrentUserResponse {
  interests: string[]
  description: string[]
  purpose: UserPurpose
  id: string
  email: string
  firstName: string
  lastName: string
  company: string
  role: string
  step: string
  marketingMailing: boolean
  isSuperadmin: boolean
  isLetIn: boolean
  createdAt: string
  updatedAt: string
  avatarUrl: string
}

export interface JoinTenantBody {
  invitationToken: string
}

export interface UpdateAvatarResponse {
  avatar: string
}

export interface CreateUserBody {
  firstName: string
  lastName: string
  marketingMailing: boolean
  description: string
  purpose: string
  company: string
}

export interface ChangePasswordBody {
  oldPassword: string
  newPassword: string
  confirmNewPassword: string
}
